<!--
  This file is part of vospace-ui
  Copyright (C) 2021 Istituto Nazionale di Astrofisica
  SPDX-License-Identifier: GPL-3.0-or-later
-->
<template>
<b-navbar-nav>
  <b-nav-item href="#/jobs">
    <strong>Jobs</strong>&nbsp;
    <b-badge variant="light">{{jobs.length}} <span class="sr-only">unread messages</span></b-badge>
  </b-nav-item>
</b-navbar-nav>
</template>

<script>
export default {
  computed: {
    jobs() { return this.$store.state.jobs }
  }
}
</script>
